<template>
  <div class="enEspera">
    <strong class="titulo-motivo"> Ayuda con la compra </strong>
    <div class="" v-if="[11, 12].includes(datos.datos_reclamo[0].motivo_id)">
      <p class="titulo-reclamo">
        Solicitaste la cancelación
        <strong v-if="datos.datos_reclamo[0].motivo_id == 12">parcial</strong>
        <strong v-if="datos.datos_reclamo[0].motivo_id == 11">total</strong> de
        tu pedido el día
        <strong>{{
          $date(datos.datos_reclamo[0].fecha_creacion.date).format("LLL")
        }}</strong>
      </p>
      <h1 class="nro-reclamo" v-if="number_case_or > 0">
        <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
        {{ number_case_or || number_case }}
      </h1>

      <p>
        Estamos verificando la información de tu pedido para realizar la
        operación correspondiente.
      </p>

      <p>
        Recibirás la respuesta a tu consulta por mail.
      </p>
    </div>
    <div class="" v-if="[3, 7].includes(datos.datos_reclamo[0].motivo_id)">
      <p class="titulo-reclamo">
        Recibimos tu consulta:
        <strong>{{ datos.datos_reclamo[0].motivo }}</strong>
      </p>
      <h1 class="nro-reclamo" v-if="number_case_or > 0">
        <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
        {{ number_case_or || number_case }}
      </h1>
      <p>
        Vamos a verificar que sucedió con tu pedido, recibirás notificaciones en
        el correo registrado.
      </p>
      <p>
        Recibirás la respuesta a tu consulta por mail.
      </p>
    </div>
    <div class="" v-if="[8, 21].includes(datos.datos_reclamo[0].motivo_id)">
      <div v-if="!dias30 && datos.datos_reclamo[0].motivo_id == 21" class="solicitudOpcion">
        <!-- <p>Reclamo oi </p> -->
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }}</strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p>
          Lamentamos los problemas ocasionados, Deberás dirigirte al punto de
          retiro seleccionado para retirar tu pedido
          <br />
          <br />
        </p>
        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>
      </div>
      <div v-if="!dias30 && datos.datos_reclamo[0].motivo_id == 8" class="solicitudOpcion">
        <!-- <p>Reclamo oi </p> -->
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }} </strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p>
          Verificaremos el estado de tu pedido, nos pondremos en contacto con
          vos por este medio, las notificaciones las recibirás por mail.
          <br />
          <br />
        </p>
        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>
      </div>
      <div v-if="dias30" class="solicitudOpcion">
        <!-- <p>Reclamo oi </p> -->
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }} </strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p>
          Transcurrieron mas de 30 días desde tu compra y el pedido fue devuelto
          a nuestro deposito. Hemos generado el reintegro de tu dinero
          <br />
          <br />
          Te recomendamos que verifiques a través del mismo medio por el cual
          realizaste el pago su estado, los tiempos estimados son: <br />
          <strong>Billetera Mercado Pago: 72 Hs</strong> <br />
          <strong>Tarjeta de Débito o Crédito: 2 a 35 días.
            <br />
            <small>estos plazos dependen de tu banco y el cierre mensual de cada
              tarjeta</small>
          </strong>
        </p>
        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>
      </div>
    </div>
    <div class="" v-if="[2, 9].includes(datos.datos_reclamo[0].motivo_id)">
      <div v-if="
        (datos.datos_reclamo[0] && datos.datos_reclamo[0].articulo &&
          datos.datos_reclamo[0].articulo.tipo_operacion &&
          datos.datos_reclamo[0].articulo.tipo_operacion == 'renviar') ||
        (datos.datos_reclamo[0] &&
          datos.datos_reclamo[0].tipo_operacion == 'renviar')
      " class="solicitudOpcion">
        <!-- <p>Reclamo oi </p> -->
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }} / quiero que me envien los
            productos</strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p class="titulo-reclamo" v-if="parseInt(datos.datos_reclamo[0].precio_total) > 500">
          Te pedimos disculpas por el inconveniente verificaremos que los
          productos tengan stock y te los reenviaremos al punto de retiro
          seleccionado.

          <br />
          <br />
          <!-- <span
            >Tiempo estimado de resolución: <br />
            <strong>10 días hábiles</strong></span
          >
          <br /> -->
        </p>
        <p v-else>
          Te pedimos disculpas por el inconveniente debido al costo total de los
          productos faltantes, no es posible realizar un reenvio por lo que
          procederemos a realizar la devolución del dinero.
          <br />
          <span>
            si es necesario, un asesor se comunicará con vos
            <br />
            <br />
            Tiempos estimados de acreditación <br />
            <strong>Billetera Mercado Pago: 72 Hs</strong> <br />
            <strong>Tarjeta de Débito o Crédito: 2 a 35 días.
              <br />
              <small>estos plazos dependen de tu banco y el cierre mensual de cada
                tarjeta</small>
            </strong> </span><br />
        </p>
        <!-- <p v-if="number_case_or > 0">
          Nro de consulta
          <strong v-if="number_case_or > 0">{{ number_case_or }}</strong>
          <strong v-if="!number_case_or">{{ number_case }}</strong>
        </p> -->
      </div>
      <div v-if="
        (datos.datos_reclamo[0].articulo && datos.datos_reclamo[0].articulo &&
          datos.datos_reclamo[0].articulo.tipo_operacion &&
          datos.datos_reclamo[0].articulo.tipo_operacion == 'cancelar') ||
        (datos.datos_reclamo[0] &&
          datos.datos_reclamo[0].tipo_operacion == 'cancelar')
      " class="solicitudOpcion">
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }} / quiero solicitar la
            devolución del dinero
          </strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p>
          Te pedimos disculpas por el inconveniente verificaremos los datos de
          tu compra y en caso de corresponder realizaremos la devolución del
          dinero automáticamente. Recibirás el comprobante de devolución en tu
          correo.
          <span>Si es necesario un asesor se comunicará con vos. <br />
            <br />
            Tiempos estimados de acreditación <br />
            <strong>Billetera Mercado Pago: 72 Hs</strong> <br />
            <strong>Tarjeta de Débito o Crédito: 2 a 35 días.
              <br />
              <small>estos plazos dependen de tu banco y el cierre mensual de cada
                tarjeta</small>
            </strong> </span><br />
        </p>

        <!-- <p v-if="number_case_or > 0">
          Nro de consulta
          <strong v-if="number_case_or > 0">{{ number_case_or }}</strong>
          <strong v-if="!number_case_or">{{ number_case }}</strong>
        </p> -->
      </div>
      <div v-else class="solicitudOpcion">
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }} </strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>

      </div>
    </div>
    <div class="" v-if="[6].includes(datos.datos_reclamo[0].motivo_id)">
      <div v-if="
        (datos.datos_reclamo[0].articulo &&
          datos.datos_reclamo[0].articulo.tipo_operacion &&
          datos.datos_reclamo[0].articulo.tipo_operacion == 'renviar') ||
        (datos.datos_reclamo[0].articulo &&
          datos.datos_reclamo[0].tipo_operacion == 'renviar')
      " class="solicitudOpcion">
        <!-- <p>Reclamo oi </p> -->
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }} / quiero que me los
            reenvien</strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>

        <p>
          <span v-if="parseInt(datos.datos_reclamo[0].precio_total) > 500">
            Te pedimos disculpas por el inconveniente verificaremos que los
            productos tengan stock y te los reenviaremos al punto de retiro
            seleccionado.
            <br />
            <br />
            Para concretar el cambio y/o devolución, deberás llevar el producto
            incorrecto al punto de retiro, acompañado de la factura de compra.
            <br />

            <!-- <PuntoRetiro :datos="datos" style="background: #fff; padding: 10px; border-radius: 4px" /> -->
          </span>
          <span v-else>
            Te pedimos disculpas por el inconveniente verificaremos que los
            productos tengan stock y te los reenviaremos al punto de retiro
            seleccionado. <br />
            <strong>No es necesario devolver el producto </strong>
          </span>

          <br />

          <!-- <span
            >Tiempo estimado de resolución
            <strong>10 días hábiles</strong></span
          > 

          <br />-->

        </p>
        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>
      </div>
      <div v-if="
        (datos.datos_reclamo[0].articulo &&
          datos.datos_reclamo[0].articulo.tipo_operacion &&
          datos.datos_reclamo[0].articulo.tipo_operacion == 'cancelar') ||
        (datos.datos_reclamo[0] &&
          datos.datos_reclamo[0].tipo_operacion == 'cancelar')
      " class="solicitudOpcion">
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }} / quiero solicitar la
            devolución del dinero</strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p>
          <span v-if="parseInt(datos.datos_reclamo[0].precio_total) > 500">
            Te pedimos disculpas por el inconveniente.
            <br />

            Para concretar la devolución, deberás llevar el producto incorrecto
            al punto de retiro, acompañado de la factura de compra.
            <br />

            <!-- <PuntoRetiro :datos="datos" style="background: #fff; padding: 10px; border-radius: 4px" /> -->
          </span>
          <span v-else>
            Te pedimos disculpas por el inconveniente verificaremos los datos de
            tu compra y en caso de corresponder realizaremos la devolución del
            dinero automáticamente. Recibirás el comprobante de devolución en tu
            correo. <br />
            <strong></strong>
          </span>

          <span>Si es necesario un asesor se comunicará con vos. <br />
            <br />
            Tiempos estimados de acreditación <br />
            <strong>Billetera Mercado Pago: 72 Hs</strong> <br />
            <strong>Tarjeta de Débito o Crédito: 2 a 35 días.
              <br />
              <small>estos plazos dependen de tu banco y el cierre mensual de cada
                tarjeta</small>
            </strong> </span><br />
        </p>

        <!-- <p v-if="number_case_or > 0">
          Nro de consulta
          <strong v-if="number_case_or > 0">{{ number_case_or }}</strong>
          <strong v-if="!number_case_or">{{ number_case }}</strong>
        </p> -->
      </div>
    </div>
    <div class="" v-if="[14].includes(datos.datos_reclamo[0].motivo_id)">
      <div class="solicitudOpcion">
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }}</strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>

        <p>
          Te pedimos disculpas por el inconveniente verificaremos los datos de
          tu compra y en caso de corresponder realizaremos la devolución del
          dinero automáticamente. Recibirás el comprobante de devolución en tu
          correo.
          <span>Si es necesario un asesor se comunicará con vos. <br />
            <br />
            Tiempos estimados de acreditación <br />
            <strong>Billetera Mercado Pago: 72 Hs</strong> <br />
            <strong>Tarjeta de Débito o Crédito: 2 a 35 días.
              <br />
              <small>estos plazos dependen de tu banco y el cierre mensual de cada
                tarjeta</small>
            </strong> </span><br />
        </p>

        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>
      </div>
    </div>
    <div class="" v-if="[19].includes(datos.datos_reclamo[0].motivo_id)">
      <div class="solicitudOpcion">
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }}</strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}
        </h1>
        <p>
          Verificamos que la devolución del dinero se realizó correctamente,
          deberás ponerte en contacto con la entidad bancaria para consultar el
          estado de la misma.
        </p>

        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>
      </div>
    </div>
    <div class="" v-if="[10].includes(datos.datos_reclamo[0].motivo_id)">
      <div class="solicitudOpcion">
        <p class="titulo-reclamo">
          Recibimos tu consulta:
          <strong>{{ datos.datos_reclamo[0].motivo }}</strong>
        </p>
        <h1 class="nro-reclamo" v-if="number_case_or > 0">
          <small>Nro de consulta</small><strong>{{ estados[datos.datos_reclamo[0].wc_status] || 'Abierto' }}</strong>
          {{ number_case_or || number_case }}

        </h1>
        <p>
          Vamos a verificar que sucedió con la devolución del dinero, nos
          pondremos en contacto por este medio y recibirás una notificación a tu
          e-mail cuando tengamos novedades.
        </p>

        <p>
          Recibirás la respuesta a tu consulta por mail.
        </p>
      </div>
    </div>
    <!-- <div class="status" v-if="number_case_or > 0">
      <span >
      Estado actual de tu reclamo: 
</span>
      
      <br>
      <el-button type="danger" plain size="mini" @click="verMensajes">Ver mensajes</el-button>
      
    </div> -->
    <span class="loadingCase" element-loading-text="obteniendo número de reclamos"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)"
      v-loading="number_case < 0">
      <!-- <vue-countdown v-if="number_case < 0" :time="35 * 1000" :transform="transformSlotProps" v-slot="{seconds }">
    {{ seconds }} 
  </vue-countdown> -->
    </span>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import { EventBus } from "@/event-bus";
import VueCountdown from '@chenfengyuan/vue-countdown';

export default {
  props: ["datos"],
  name: "EnEspera",
  components: {
    // VueCountdown
    // PuntoRetiro: () => import(/* webpackChunkName: "puntoRetiro" */ "./puntoRetiro.vue"),
  },
  data() {
    return {
      dias30: false,
      estados: { "solved": "Resuelto", "closed": "Cerrado", "open": "Abierto", "pending": "Pendiente", "onhold": "Esperando su respuesta" },
      number_case: parseInt(this.datos.datos_reclamo[0].number_case) ? parseInt(this.datos.datos_reclamo[0].number_case) : -1,
      number_case_or: parseInt(this.datos.datos_reclamo[0].number_case),
    };
  },
  computed: {},
  mounted() { },
  created() {
    const enFarmaciaHasta = this.$date(this.datos.fecha_estimada.date).add(30, "day").format("DD/MM/YYYY")

    setTimeout(() => {
      this.obtenerCase();
    }, 6000);

    this.dias30 = this.$date().diff(this.datos.fecha_estimada.date, 'days') > 30 ? true : false
    console.log("this.hoy", this.$date().format('DD/MM/YYYY'));
    console.log("this.$date(enFarmaciaHasta)", this.dias30);

  },
  methods: {
    verMensajes() {
      EventBus.$emit("abriChat", this.datos);
    },
    obtenerCase() {
      if (!this.number_case_or && this.number_case < 0) {
        setTimeout(() => {
          HTTP.post("/updateNumberCase", {
            fo_pv_cab: this.datos.datos_reclamo[0].id,
            id_wc: this.datos.datos_reclamo[0].id_wc,
          }).then((res) => {
            this.number_case = res.data > 0 ? res.data : -1;
            this.number_case_or = res.data > 0 ? res.data : this.number_case_or;
            if (!res.data) {
              this.obtenerCase();
            }
          });
        }, 6000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.status {
  padding: 10px 0px;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 2px;
  /* text-align: left; */
  line-height: 2;
}

.solicitudOpcion strong {
  color: #99982b;
}

.solicitudOpcion {
  text-align: left;
  font-size: 13.5px;
  text-align: left;
  line-height: 1.2;
  color: #333;
}

.enEspera {

  height: 100vh;
  padding: 20px;
}

.enEspera>div>p {
  font-size: 13.5px;
  text-align: left;
  line-height: 1.2;
  color: #333;
}

.enEspera>div>p>strong {
  font-weight: 600;
  font-size: 15px;
  color: #99982b;
}

.enEspera>div>p>a {
  font-weight: 600;
  color: #99982b;
}

.titulo-motivo {
  display: block;
  line-height: 1.2;
  text-align: center;
  color: #333;
  font-size: 16px;
  // padding : 20px;
  // margin-top: -10px;
}

.loadingCase {
  margin-top: 50px;
  display: block;
  width: 100%;
}

.titulo-reclamo {
  background: #f3f3e6;
  padding: 20px;
  color: #99982b;
  font-weight: bold;
}

.titulo-reclamo strong {
  color: #99982b;
}
.nro-reclamo{
  position: relative;
}
.nro-reclamo small{
  display: block;

}

.nro-reclamo strong{
  display: block;
  position: absolute;
  top:0 ;
  right: 0;
  font-size: 14px;
  color: red;

}
</style>
